/**
 * Header text included at the top of generated declaration bundle files.
 *
 * @remarks
 * This constant provides a standardized header comment prepended to all
 * declaration bundle files generated by the TypeScript module. The header clearly
 * indicates that the file was automatically generated and should not be edited manually.
 *
 * The header serves as:
 * - A warning to developers not to manually modify generated files
 * - Documentation indicating the source of the file
 * - A consistent marker for identifying generated declaration files
 *
 * @example
 * ```ts
 * import { HeaderDeclarationBundle } from './typescript.constant';
 * import { writeFileSync } from 'fs';
 *
 * const bundledContent = `${HeaderDeclarationBundle}\n${actualDeclarations}`;
 * writeFileSync('dist/index.d.ts', bundledContent);
 * ```
 *
 * @since 1.5.9
 */

export const HeaderDeclarationBundle = `/**
 * This file was automatically generated by xBuild.
 * DO NOT EDIT MANUALLY.
 */
`;
